import api from './api';

export const register = async (userData) => {
  try {
    const res = await api.post("/auth/register", userData);
    return res.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const login = async (credentials) => {
  try {
    const res = await api.post("/auth/login", credentials);
    return res.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const logout = async (refreshToken) => {
  try {
    const res = await api.post("/auth/logout", { refreshToken });
    return res.data;
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};

// Note: API dokümantasyonunda user listeleme endpoint'i yok
// Bu yüzden dummy data kullanılacak
export const getUsers = async () => {
  try {
    // API'de user listesi endpoint'i olmadığı için static data döndür
    return [
      {
        id: '1',
        email: 'admin@zeepconstruction.com',
        role: 'admin',
        name: 'Admin User',
        status: 'active',
        createdAt: new Date().toISOString()
      }
    ];
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};
